<template>
  <!-- ── 幣種選單 ── -->
  <div :class="isPC ? 'colu colu-6' : 'colu colu-12 withdraw-currency-wrap'">
    <div class="colu-12 for-label">
      {{ isCryptoExchange ? $t('Bao.withdrawal_source_wallet') : $t('Bao.withdrawal_currency') }}
    </div>

    <div class="crypto-select-frame" :class="isPC ? 'withdraw-coin-wrap' : ''">
      <div class="lang-select">
        <!-- 觸發按鈕 -->
        <button class="btn-select" @click.prevent="isOpenCurrency = !isOpenCurrency">
          <li v-if="isCrypto && selectedCoin">
            <img :src="$getThemeImagePath(`crypto-${selectedCoin.symbol.toLowerCase()}.svg`)" alt="">
            <span class="wcd-name">{{ selectedCoin.symbol }}</span>
            <span class="wcd-bal">{{ selectedCoin.balance }}</span>
          </li>
          <li v-else-if="selectedWallet">
            <img :src="getWalletImagePath(selectedWallet)" alt="">
            <span class="wcd-name">{{ mainCurrencyLabel }}</span>
          </li>
        </button>

        <!-- 下拉選單 -->
        <div class="b" :class="{ active: isOpenCurrency }">
          <ul class="crypto-list">
            <!-- 一般錢包 -->
            <li
              v-if="mainWallet && !isTheme('theme_purple')"
              @click="onSelectNonCrypto(mainWallet)"
            >
              <img :src="getWalletImagePath(mainWallet)" alt="">
              <div class="affiliateWallet">
                <div class="coin">
                  {{ mainCurrencyLabel }}
                </div>
              </div>
            </li>

            <!-- 加密幣（isCryptoExchange 模式下不顯示） -->
            <template v-if="!isCryptoExchange">
              <li
                v-for="coin in coinList"
                :key="coin.coinId"
                @click="onSelectCrypto(coin)"
              >
                <img :src="$getThemeImagePath(`crypto-${coin.symbol.toLowerCase()}.svg`)" alt="">
                <div class="affiliateWallet">
                  <div class="coin">
                    {{ coin.symbol }}
                  </div>
                  <div class="wallet">
                    {{ coin.balance }}
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>

        <!-- 手續費提示 -->
        <div
          v-if="isCrypto && selectedCoin && selectedCoin.payment_fee && selectedCoin.payment_fee !== 0"
          class="input-feedback remarks text-align-R"
        >
          {{ $t('Bao.payment_fee') }} {{ selectedCoin.payment_fee }} %
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWalletImagePath, detectMob } from '@/utils/tool'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'CoinSelector',
  mixins: [themeMixin],
  props: {
    /** 是否為加密幣模式 */
    isCrypto: {
      type: Boolean,
      default: false
    },
    isCryptoExchange: {
      type: Boolean,
      default: false
    },
    selectedCoin: {
      type: Object,
      default: null
    },
    selectedWallet: {
      type: Object,
      default: null
    },
    coinList: {
      type: Array,
      default: () => []
    },
    mainWallet: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isOpenCurrency: false,
      isOpenChain: false
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    },
    mainCurrencyLabel() {
      if (this.isTheme('theme_blue')) return 'UBD'
      if (this.isTheme('theme_purple')) return 'JRA'
      return this.mainWallet && this.mainWallet.currency ? this.mainWallet.currency : 'JPY'
    }
  },
  methods: {
    getWalletImagePath,
    onSelectNonCrypto(wallet) {
      this.isOpenCurrency = false
      this.isOpenChain = false
      this.$emit('select-non-crypto', wallet)
    },
    onSelectCrypto(coin) {
      this.isOpenCurrency = false
      this.$emit('select-crypto', coin)
    }
  }
}
</script>
